import React from 'react';
import { OrderInfo, OrderInfoDelivery } from 'common/types';
import RentalCardStartTime from './RentalCardStartTime';
import RentalCardWaitTime from './RentalCardWaitTime';
import RentalCardDeliveryTime from './RentalCardDeliveryTime';
import RentalCardCarrierInfo from './RentalCardCarrierInfo';
import { getRentalDeliveryStartTime } from 'common/utils/dateCalculations';
import { useTranslation } from 'services/localization/useTranslation';
import moment from 'moment-timezone';

interface Props {
	rentalInfo: OrderInfo;
	dateExpired?: boolean | undefined;
	delivery?: OrderInfoDelivery | undefined;
}
const BookedRentalCardStatus = (props: Props) => {
	const { rentalInfo, dateExpired, delivery } = props;
	const { t } = useTranslation();
	const wait =
		rentalInfo.channel === 'STORE' &&
		moment(rentalInfo.created).isSameOrAfter(moment().subtract(45, 'minutes')) &&
		moment(rentalInfo.created).isSameOrAfter(moment(rentalInfo.startDate).subtract(45, 'minutes'));
	return (
		<>
			{dateExpired && rentalInfo.startDate ? (
				<RentalCardStartTime creationDate={rentalInfo.created} startDate={rentalInfo.startDate} />
			) : wait ? (
				<RentalCardWaitTime rentalCreateTime={rentalInfo.created} />
			) : delivery?.to ? (
				<>
					<RentalCardDeliveryTime
						deliveryDate={getRentalDeliveryStartTime(rentalInfo)}
						informationText={t('rentalCard.mustBePreparedBy')}
						spacing="normal"
					/>
					{delivery.to?.carrierId && <RentalCardCarrierInfo carrierId={delivery.to.carrierId} />}
				</>
			) : (
				<RentalCardStartTime creationDate={rentalInfo.created} startDate={rentalInfo.startDate} />
			)}
		</>
	);
};

export default BookedRentalCardStatus;
